@if(isDisabled){
<app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        Online User Rights
    </div>
    <div class="card-body">
        <div class="row">
            <!-- <div class="col-auto">
                <label class="mt-2">User<span class="text-danger">*</span></label>
            </div> -->
            <div class="col-md-5">
                <ng-select name="user" placeholder="Select User" [items]="Users" bindLabel="UserName"
                    bindValue="UserMasterId" [(ngModel)]="Detail.UserMasterID" (change)="clear()">
                </ng-select>
                <div class="invalid-feedback fs-7">
                    Please select user
                </div>
            </div>
            <div class="col-auto">
                <button (click)="GetUserOnlineRights()" class="btn btn-primary btn-sm">
                    <i class="bi bi-search"></i> Search
                </button>
            </div>
        </div>

        <div class="row mt-3">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th>Sitename</th>
                        <th>Before Days</th>
                        <th>After Days</th>
                        <th>Remove</th>
                        <th>Reset</th>
                        <th>Update Designation</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let e of Tabledata; let i = index">
                        <td>{{i+1}}</td>
                        <td>{{e['SiteName']}}</td>
                        <td>
                            <!-- {{e['AttendanceBeforeDaysAllowed']}} -->
                            <input type="text" [disabled]="!CompanyPermiter.IsAttendanceBeforeDaysAllowed" class="form-control" name="beforedays{{i}}" [(ngModel)]="e.AttendanceBeforeDaysAllowed">
                        </td>
                        <td>
                            <!-- {{e['AttendanceAfterDaysAllowed']}} -->
                            <input type="text" [disabled]="!CompanyPermiter.IsAttendanceAfterDaysAllowed" class="form-control" name="afterdays{{i}}" [(ngModel)]="e.AttendanceAfterDaysAllowed">
                        </td>
                        <td style="text-align: center;">
                            <input [disabled]="!CompanyPermiter.IsAttendanceDeleteAllowed" class="form-check-input" name="remove{{i}}" id="rem{{i}}" type="checkbox"
                                [(ngModel)]="e.IsAttendanceDeleteAllowed" [checked]="e['IsAttendanceDeleteAllowed']" />
                        </td>
                        <td style="text-align: center;">
                            <input [disabled]="!CompanyPermiter.IsAttendanceResetAllowed" class="form-check-input" name="reset{{i}}" id="res{{i}}" type="checkbox"
                                [(ngModel)]="e.IsAttendanceResetAllowed" [checked]="e['IsAttendanceResetAllowed']" />
                        </td>
                        <td style="text-align: center;">
                            <input [disabled]="!CompanyPermiter.IsUpdateDesignationDutyAllowed" class="form-check-input" name="designation{{i}}" id="des{{i}}" type="checkbox"
                                [(ngModel)]="e.IsUpdateDesignationDutyAllowed" [checked]="e['IsUpdateDesignationDutyAllowed']" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="Save()" [disabled]="isDisabled" class="btn btn-primary btn-sm">Save</button>
            </div>
        </div>
    </div>
</div>